import { formatTime } from "V2.0/utils";

import useActiveCallsState from "./useActiveCallState";

import CallConcurrency from "./CallConcurrency";
import PendingCalls from "./PendingCalls";
import PausedCalls from "./PausedCalls";

import { Button } from "V2.0/common/button";
import { ArrowPathIcon } from "@heroicons/react/24/outline";

export default function ActiveCallsStats(props) {
  const { workspaceId, assistantId, locked } = props;
  const {
    state,
    fetchCurrentQueueStats,
    pausePendingCalls,
    cancelPendingCalls,
    queuePausedCalls,
    cancelPausedCalls
  } = useActiveCallsState(workspaceId, assistantId);

  return (
    <div className="flex flex-col border rounded-lg">
      <div className="px-4 py-2">
        <div className="flex items-center">
          <p className="text-base font-semibold">Active Calls</p>
          <Button
            onClick={fetchCurrentQueueStats}
            plain
          >
            <ArrowPathIcon />
          </Button>
        </div>
        <div>
          <p className="text-xs">Last Updated at: {formatTime(Date.now())}</p>
        </div>
      </div>
      <div className="p-4">
        <CallConcurrency
          isLoading={state.isLoading}
          concurrentCalls={state.concurrentCalls}
          concurrencyLimit={state.concurrencyLimit}
        />
      </div>
      <div className="flex space-x-4 p-4">
        <PendingCalls
          isLoading={state.isLoading}
          pendingCalls={state.pendingCalls}
          onPausePendingCalls={pausePendingCalls}
          onCancelPendingCalls={cancelPendingCalls}
          fetchCurrentQueueStats={fetchCurrentQueueStats}
          locked={locked}
        />
        <PausedCalls
          isLoading={state.isLoading}
          pausedCalls={state.pausedCalls}
          onQueuePausedCalls={queuePausedCalls}
          onCancelPausedCalls={cancelPausedCalls}
          fetchCurrentQueueStats={fetchCurrentQueueStats}
          locked={locked}
        />
      </div>
    </div>
  );
}
